import ContactUs, { IContactUsState } from '@sunbit-dev/ui/src/components/card-apply/pages/contactUs/ContactUs';
import React from 'react';
import fetch from '@sunbit-dev/common/services/fetch';

const ContactUsContainer: React.FC = () => {
  const [isDone, setIsDone] = React.useState(false);

  const submit = React.useCallback(async (values: IContactUsState) => {
    try {
      await fetch(`/contactus`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(values)
      });
    } catch (e) {
      // silent failure
    } finally {
      setIsDone(true);
    }
  }, []);

  const props = {
    isDone,
    submit
    // submit: (values: IContactUsState) => console.log(values),
  };

  return <ContactUs {...props} />;
};

export default ContactUsContainer;
